import { FormControlLabel, Grid } from "@material-ui/core";
import { StyledSwitch } from "../styled-switch/StyledSwitch";
import StyledSlider from "../styled-slider/StyledSlider";
import FilePicker from "../file-picker/FilePicker";
import { useDispatch, useSelector } from "react-redux";
import {
  setAutoRotate,
  setEnvironmentImage,
  setExposure,
  setShadowIntensity,
  setShadowSoftness,
  setUseSkybox,
} from "../../store/slices/EnvironmentSlice";
import React from "react";

const Environment = () => {
  const environment = useSelector((state) => state.environment);
  const dispatch = useDispatch();

  const handleExposureChange = (value) => dispatch(setExposure(value));
  const handleShadowIntensityChange = (value) =>
    dispatch(setShadowIntensity(value));
  const handleShadowSoftnessChange = (value) =>
    dispatch(setShadowSoftness(value));
  const handleEnvironmentImageChange = (value) =>
    dispatch(setEnvironmentImage(value));

  const types = ["hdr"];
  return (
    <div>
      <h6 className={"p-3"}>Lighting</h6>
      <div className={"inner-box"}>
        <Grid
          container
          className={"p-3"}
          style={{ borderBottom: "1px solid #141414ba" }}
        >
          <Grid item xs={12}>
            <div className={"mb-3 px-2"}>Add environment image </div>
            <FilePicker
              formats={"hdri"}
              updateFileUrl={handleEnvironmentImageChange}
              types={types}
            />
          </Grid>
        </Grid>
        <Grid container className={"p-3"}>
          <Grid item xs={12}>
            <StyledSlider
              label={"Exposure"}
              iniValue={environment.exposure}
              handleChange={handleExposureChange}
            />
            <StyledSlider
              label={"Shadow Intensity"}
              iniValue={environment.shadowIntensity}
              handleChange={handleShadowIntensityChange}
            />
            <StyledSlider
              label={"Shadow Softness"}
              iniValue={environment.shadowSoftness}
              handleChange={handleShadowSoftnessChange}
            />
          </Grid>
        </Grid>
      </div>
      <h6 className={"p-3"}>Configuration</h6>
      <div className={"inner-box"}>
        <Grid container className={"p-3"}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <StyledSwitch
                  checked={environment.autoRotate}
                  onChange={() => dispatch(setAutoRotate())}
                  name="checkedB"
                />
              }
              label="Auto Rotate"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <StyledSwitch
                  checked={environment.useSkybox}
                  onChange={() => dispatch(setUseSkybox())}
                  name="checkedB"
                />
              }
              label="Use environment image as skybox"
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Environment;
